import React, { useEffect, useState } from "react";
import BreadCrumbs from "@components/breadcrumbs/index1";
import { useTranslation } from "react-i18next";
import { get_users_by_product } from "@src/redux/action/access_control/UsersAction";
import { useDispatch, useSelector } from "react-redux";
import UsersCard from "./UsersCard";
import ReactPaginate from "react-paginate";
const Team = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    dispatch(
      get_users_by_product({
        page: currentPage,
        per_page: 6,
      })
    );
  }, [currentPage]);
  const { t } = useTranslation();
  const user_by_product = useSelector(
    (state) => state.UserReducers.users_by_product_id
  );
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
  };

  return (
    <div>
      <BreadCrumbs breadCrumbTitle={t("Team")} />
      <div className="treanding_songs_wrapper release_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "80%" }}>
          {user_by_product?.data && user_by_product?.data.length ? (
            <>
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="tab-content">
                    <div className="row">
                      {user_by_product?.data?.map((user, i) => (
                        <UsersCard user={user} key={`users_by_producr${i}`} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="blog_pagination_section ms_cover">
                <ReactPaginate
                  previousLabel={
                    <p className="prev">
                      <i className="flaticon-left-arrow" />
                    </p>
                  }
                  nextLabel={
                    <p className="next">
                      <i className="flaticon-right-arrow" />
                    </p>
                  }
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={2}
                  pageCount={user_by_product.last_page || 1}
                  breakLabel="..."
                  activeClassName="third_pagger"
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  onPageChange={(page) => handlePageChange(page)}
                  pageClassName={"page-item"}
                  containerClassName={
                    "pagination react-paginate justify-content-end p-1"
                  }
                />
              </div>
            </>
          ) : (
            <h6
              style={{
                margin: "120px 0",
              }}
              className="text-black text-center"
            >
              {t("No users Found")}
            </h6>
          )}
        </div>
      </div>
    </div>
  );
};

export default Team;
